import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";

export type IBFTerminateBasal = {
  timeLeft: number;
};

export const IBF_TERMINATE_BASAL = {
  value: 0x4000,
  name: "IBF_TERMINATE_BASAL",
  size: 2,
  parse: (record): IBFTerminateBasal => {
    const timeLeft = record.nextUInt16LE() * 60 * 1000;
    return {
      timeLeft,
    };
  },
} satisfies IBFHistoryRecordDefinition<IBFTerminateBasal>;
